import {IRegion} from "../../varibles/interface";
import {createSliceSelectors} from "../selectors";

export const NAME_SLICE = 'region'

export interface RegionState {
    data: IRegion[]

    loading: boolean
}

export const initialState: RegionState = {
    data: [],

    loading: false,
}

const selectors = createSliceSelectors(NAME_SLICE, initialState);

export const selectRegion = {
    ...selectors,
    regions: selectors.data,
};
